import React from 'react'

const Features = () => {
    return ( 
        <>
        { /* feature container start */ } 
        <div className = "flex flex-wrap lg:flex-nowrap items-center mb-5" > 
        { /* feature heading container start */ } 
            <div className = "order-2 lg:order-1 w-full lg:w-4/6" >
            
                <h4 className = "feature-heading-a1" >
                Easy to Handle and Implant 
                </h4> 
            </div> 
            { /* feature heading container end */ } 
        </div> { /* feature container end */ }


        { /* feature container start */ }

        { /* feature first row start */ } 
        <div className = "flex flex-wrap lg:flex-nowrap items-start mb-20" >

            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a3" >
                FLEXIBLE STENT </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                    CROWN PRT’ s flexible stent provides resilience towards possible 
                    deformations during implant and robustness towards creep over time.<sup>*</sup>
                </p >
                <img src = "/images/crown_prt/Flexible-stent.png"className = "mx-auto w-full md:w-4/5" />
            </div> 
            { /* content block End */ } 

            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a3" >
                VISIBLE MARKERS </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                CROWN PRT’ s sewing cuff visible markers are aimed to help precise 
                valve placement and evenly distribute sutures.</p >
                <img src = "/images/crown_prt/Visible-markers.png"className = "mx-auto w-full md:w-4/5" />
            </div> 
            { /* content block End */ } 

            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a3" >
                 RADIOPAQUE MARKERS </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                    CROWN PRT’ s sewing cuff offers radiopaque information on its precise 
                    position through a specially shaped insert, impregnated with tungsten powder. 
                </p> 
                <img src = "/images/crown_prt/RADIOPAQUE-markers.png"className = "mx-auto w-full md:w-4/5" / >
            </div>
            { /* content block End */ } 

        </div> { /* feature container end */ }
        
        { /* feature First row end */ } 
        <div className = "w-full " >
            <p className = "text-sm 2xl:text-base mb-6 feature-p-text xl:w-4/5 italic" >
            <sup>*</sup>CORCYM data on file.
            </p>
        </div> 
        { /* feature Second row start */ } 
        { /* feature heading container start */ } 
        <div className = "order-2 lg:order-1 w-full lg:w-4/6" >
            <h4 className = "feature-heading-a1" >
            Versatile </h4> 
        </div> 
        { /* feature heading container end */ } 
       
        <div className = "flex flex-wrap lg:flex-nowrap items-center mb-20" >

            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a2 font-bold" >
                SLIM, ELASTIC SEWING CUFF </h4> 
                <p className = "text-sm 2xl:text-base mb-12 feature-p-text" >
                    The malleable sewing cuff facilitates implantation by allowing conformability 
                    to different types of annuli, even stiff / calcified and / or irregular roots. <br/>
                </p> 
                <p className = "font-bold feature-p-text"> 
                    “The slim sewing ring also serves this goal and is slightly malleable 
                    so that implantation in stiff roots is facilitated.” < sup>1 </sup> 
                </p> 
                <img src = "/images/crown_prt/Slim.png"className = "mx-auto w-full md:w-2/5 " />
            </div> 
            { /* content block End */ } 
            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a2 font-bold" >
                LOW PROFILE TISSUE VALVE </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                Clearance of both coronary ostia and sino - tubular junction is assured,
                even in narrow aortic roots. The low / flat profile also allows the Surgeon great 
                visibility of the aortic anatomy during the procedure. 
                </p> 
                <p className = "font-bold feature-p-text"> “Coronary clearance is ensured by the flat profile, which also 
                    facilitates knot lowering.” < sup > 1 </sup> 
                </p> 
                <img src = "/images/crown_prt/Low-profile.png"className = "mx-auto w-full md:w-2/5"/>
            </div>
            { /* content block End */ } 

        </div> { /* feature container end */ }

        { /* feature second row end */ } 


        { /* feature third row start */ } 
        { /* feature heading container start */ } 
        <div className = "order-2 lg:order-1 w-full lg:w-4/6" >
            <h4 className = "feature-heading-a1" >
            Valve design </h4> 
        </div> 
        { /* feature heading container end */ } 
        
        <div className = "flex flex-wrap lg:flex-nowrap items-start mb-20" >

            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a2 font-bold" >
                    SINGLE BOVINE PERICARDIUM OUTER LAYER </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                    CROWN PRT’s single bovine pericardium layer is mounted outside the stent.
                    This optimizes hemodynamic performance by maximizing the flow area through a 
                    synchronous and unimpeded opening of the leaflets.< sup > 2 </sup>
                </p >
                <img src = "/images/crown_prt/Single-bovine.png"className = "mx-auto w-full md:w-2/5 lg:w-3/5" />
            </div> 
            
            { /* content block start */ } 
            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a2 font-bold" >
                    ONE-SEAM KNIT
                    POLYESTER </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                    It allows for a smooth contact surface
                    between pericardium and synthetic
                    material. Cushioned leaflet contact may
                    reduce pericardium wear, enhancing
                    valve durability.
                </p >
                <img src = "/images/crown_prt/One-seam-.png" className = "mx-auto w-full mt-20 md:w-2/5 lg:w-3/5" />
            </div> 
            { /* content block start */ } 

            <div className = "order-2 lg:order-1 w-full lg:pr-10" >
                <h4 className = "feature-heading-a2 font-bold" >
                    CROSS-STITCH
                    PATTERN </h4> 
                <p className = "text-sm 2xl:text-base mb-8 feature-p-text" >
                    By distributing stress on the
                    commissures, pressure forces
                    on the valve posts may be relieved
                    during the cardiac cycle.</p> 
                <img src = "/images/crown_prt/Cross-stitch.png" className = "mx-auto w-full mt-20 md:w-2/5 lg:w-3/5" />
            </div>

        </div> { /* feature container end */ }

        { /* feature third row End */ } 


        { /* feature fourth row start */ } 

        { /* feature heading container start */ } 
        <div className = "order-2 lg:order-1 w-full lg:w-4/6" >
            <h4 className = "feature-heading-a1" >
            Treated to Last  </h4> 
        </div> 
        { /* feature heading container end */ }
        <div className=" mb-24">
                {/* feature text container start */}
                <div className=" w-full ">
                    <h4 className="feature-heading-a2 font-bold">
                        PHOSPHOLIPID REDUCTION TREATMENT (PRT) 
                    </h4>
                    <p className="text-sm 2xl:text-base mb-8 feature-p-text">
                        The presence of phospholipids in the pericardial tissue play a key role
                        in the calcification process of bioprostheses as their phosphate heads
                        are potential binding sites for circulating calcium ions.
                        <br/>
                        Crown PRT features CORCYM’s patented PRT which has proved to
                        decrease phospholipid content in pericardial tissue leading to a
                        remarkable reduction of calcium uptake compared to control tissue.<sup>*</sup>
                        <br/>
                        The PRT process removes phospholipids using Octanediol, a long
                        chain alcohol that possesses a lipid-soluble tail to aid its solubility in
                        phospholipids heads and a water-soluble head to allow removal by
                        rinsing pericardial layers before valve manufacturing.
                    </p>
                </div>
                {/* feature text container end */}

                {/* feature image container start */}
                <div className=" w-full mb-4">
                    <img src="/images/crown_prt/Treated-to-Last-.png" className=" w-full" style={{maxWidth: "700px"}}/>
                </div>
                {/* feature image container end */}
            </div>
            {/* feature container end */}







        { /* feature container start */ } 
        <div> 
            { /* feature text container start */ } 
            <div className = "w-full " >
                <p className = "text-sm mb-6 feature-p-text xl:w-4/5 italic" >
                <sup>*</sup>CORCYM data on file.
                </p>
            </div> 
            { /* feature text container end */ }

        </div> { /* feature container end */ }


        </>
    )
}

export default Features